export default __webpack_public_path__ + "static/econinja-daddd2f7516ae7f1bbb68259c3d5a140.png";